export const setIsBulkActive = isBulkActive => {
	return { type: 'SET_IS_BULK_ACTIVE', isBulkActive };
};

export const setBulkActivities = bulkActivities => {
	return { type: 'SET_BULK_ACTIVITIES', bulkActivities };
};